import React, { useState } from 'react'
import PropTypes from 'prop-types'

// import { useLazyQuery, useMutation } from '@apollo/client'
import dynamic from 'next/dynamic'

import styles from '@assets/scss/components/page-header.module.scss'
// import { TOAST_TYPE } from '@shared-submodule/sm-constants'
// import { ToastrContext } from '@shared/components/toastr'
// import { ADD_FAVOURITE, DELETE_FAVOURITE } from '@graphql/category/category.mutation'
// import { GlobalEventsContext } from '../global-events'
import useModal from '@shared/hooks/useModal'

import Skeleton from '@shared/components/skeleton'
import MyImage from '@shared/components/myImage'
import { getImgURL, convertDt24h } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import seriesPlaceholderSquare from '@assets/images/placeholder/seriesPlaceholderSquare.svg'
import custStyles from './style.module.scss'

const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'), {
  loading: () => (
    <div className="d-flex">
      <Skeleton width={'20px'} />
      <Skeleton width={'40px'} className={'ms-2 me-2'} />
      <Skeleton width={'20px'} />
    </div>
  )
})
// const SocialShare = dynamic(() => import('@shared/components/socialShare'))
const LoginModal = dynamic(() => import('@shared/components/loginModal'))

const PageHeader = ({ isFavorite: favItem, id, type, name, favBtn, desc, category, showHeaderImg, isSeries }) => {
  // const { dispatch } = useContext(ToastrContext)
  // const { stateGlobalEvents } = useContext(GlobalEventsContext)
  // const [isFavorite, setIsFavorite] = useState(favItem)
  const [showMore, setShowMore] = useState(false)
  const { isShowing, toggle } = useModal()
  // const token = getToken()

  // const [checkCategoryIsFav] = useLazyQuery(IS_FAVORITE_CATEGORY, {
  //   fetchPolicy: 'network-only',
  //   variables: { input: { _id: id } },
  //   onCompleted: (data) => {
  //     setIsFavorite(data?.getCategoryByIdFront?.bIsFav)
  //   }
  // })
  // const [checkTagIsFav] = useLazyQuery(IS_TAG_FAVORITE, {
  //   fetchPolicy: 'network-only',
  //   variables: { input: { _id: id, eType: type } },
  //   onCompleted: (data) => {
  //     setIsFavorite(data?.getTagByIdFront?.bIsFav)
  //   }
  // })

  const handleDesc = () => {
    setShowMore(!showMore)
  }

  // const handleFavorite = (isFavorite) => {
  //   if (token) {
  //     if (isFavorite) {
  //       deleteFavorite({ variables: { input: { iPageId: id } } })
  //     } else {
  //       addFavorite({ variables: { input: { eType: type, iId: id } } })
  //     }
  //   } else {
  //     toggle()
  //   }
  // }

  // const [addFavorite] = useMutation(ADD_FAVOURITE, {
  //   onCompleted: (data) => {
  //     if (data && data.addFavourite !== null) {
  //       dispatch({
  //         type: 'SHOW_TOAST',
  //         payload: { message: data.addFavourite.sMessage, type: TOAST_TYPE.Success }
  //       })
  //       setIsFavorite(true)
  //     }
  //   }
  // })

  // const [deleteFavorite] = useMutation(DELETE_FAVOURITE, {
  //   onCompleted: (data) => {
  //     if (data && data.deleteFavourite !== null) {
  //       dispatch({
  //         type: 'SHOW_TOAST',
  //         payload: { message: data.deleteFavourite.sMessage, type: TOAST_TYPE.Success }
  //       })
  //       setIsFavorite(false)
  //     }
  //   }
  // })

  // useEffect(() => {
  //   if (stateGlobalEvents && stateGlobalEvents.favouriteData === id) {
  //     setIsFavorite(false)
  //   }
  // }, [stateGlobalEvents])

  // useEffect(() => {
  //   setIsFavorite(favItem)
  //   const t = getToken()
  //   if (t && t !== 'undefined' && t !== 'null' && type) {
  //     if (type === 's' || type === 'as' || type === 'fac') checkCategoryIsFav()
  //     else checkTagIsFav()
  //   }
  // }, [id])

  // function setText(text) {
  //   if (text.length <= 150) return text
  //   if (text.length > 150 && showMore) {
  //     return text
  //   }
  //   if (text.length > 150 && !showMore) {
  //     return text.slice(0, 150) + '...'
  //   }
  // }

  return (
    <>
      <section className={`${styles.pageHeader}`}>
        <div className="d-flex align-items-start justify-content-between">
          <BreadcrumbNav dynamicName={name} />
          {/* <SocialShare /> */}
        </div>
        <div className={`${styles.title} d-flex align-items-start align-items-md-center mt-2`}>
          {showHeaderImg && (
            <div className={`  ${styles.headerImg} ${isSeries && custStyles.imageCntr}`}>
              <MyImage
                src={getImgURL(category?.oImg?.sUrl) || seriesPlaceholderSquare}
                alt={name}
                errorImage={seriesPlaceholderSquare}
                blurDataURL={BLUR_DATA_URL_BASE64}
                placeholder="blur"
                height="86"
                width="86"
                layout="responsive"
                sizes="(max-width: 767px) 120px, (max-width: 991px) 180px, (max-width: 1190px) 200px, 240px"
              />
            </div>
          )}
          <div className={`d-flex flex-wrap flex-md-column xsmall-text ${styles.infoContainer}`}>
            <h1 className={isSeries && custStyles.header}>{name === 'WWE' ? 'WWE News' : name}</h1>
            {category?.oSeries && showHeaderImg && (
              <>
                <p className={`${isSeries && custStyles.info} ${styles.info} `}>
                  <span className={styles.dotSymbol}>{category?.oSeries?.sGameFormat}</span>
                  <span className={styles.dotSymbol}>{`${category?.oSeries?.nTotalMatches} Matches`}</span>
                  <span>{`${category?.oSeries?.nTotalTeams} Teams`}</span>
                </p>
                <div className={`${styles.dates} ${isSeries && custStyles.dates}`}>
                  {`${convertDt24h(category?.oSeries?.dStartDate)} - ${convertDt24h(category?.oSeries?.dEndDate)}`}
                </div>
              </>
            )}
          </div>
          {/* <div className={styles.infoContainer}>
            <div className={styles.info}>
              <span className={styles.format}>{category?.oSeries?.sGameFormat}</span>
              <span className={styles.matches}>{category?.oSeries?.nTotalMatches}</span>
              <span className={styles.matches}>{category?.oSeries?.nTotalTeams}</span>
            </div>
          </div> */}
          {/* {favBtn && (
            <Button
              onClick={() => handleFavorite(isFavorite)}
              className={`${!isFavorite && 'outline-btn'} theme-btn small-btn  mt-2 mt-md-0 ms-0 ms-md-2 ms-xl-3 flex-shrink-0`}
            >
              {t(isFavorite ? 'common:AddedToFavorite' : 'common:AddToFavorite')}
            </Button>
          )} */}
        </div>
        {/* {props.desc && <p className='big-text'>{props.desc}</p>} */}
        {desc && (
          <div
            className={`${styles.desc} ${showMore && styles.active} ${!showMore && styles.clamp} big-text`}
            dangerouslySetInnerHTML={{ __html: desc }}></div>
        )}

        {desc && desc.length > 550 && (
          <div>
            <a className={styles.readMore} onClick={handleDesc}>
              {showMore ? 'Read Less' : 'Read More'}
            </a>
          </div>
        )}
      </section>
      {isShowing && <LoginModal isConfirm={isShowing} closeConfirm={toggle} />}
    </>
  )
}

PageHeader.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  desc: PropTypes.string,
  favBtn: PropTypes.bool,
  link: PropTypes.string,
  type: PropTypes.string,
  isFavorite: PropTypes.bool,
  category: PropTypes.object,
  showHeaderImg: PropTypes.bool,
  isSeries: PropTypes.bool
}

export default PageHeader
